import { getTrackingHandler } from './getTrackingHandler';
const errorsTrackingDescription = new Map([]);
export const errorsTrackingHandler = getTrackingHandler(errorsTrackingDescription);